import { createTheme } from '@mui/material/styles';

// Dark theme with purple/violet accents (different from Pellesmith's blue)
const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#8b5cf6', // Violet
      light: '#a78bfa',
      dark: '#7c3aed',
    },
    secondary: {
      main: '#22c55e', // Green accent
      light: '#4ade80',
      dark: '#16a34a',
    },
    background: {
      default: '#0f172a', // Deep slate
      paper: '#1e293b',
    },
    text: {
      primary: '#f1f5f9',
      secondary: '#94a3b8',
    },
    error: {
      main: '#ef4444',
    },
    success: {
      main: '#22c55e',
    },
    warning: {
      main: '#f59e0b',
    },
    info: {
      main: '#3b82f6',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontFamily: '"JetBrains Mono", monospace',
      fontWeight: 700,
      letterSpacing: '-0.02em',
    },
    h2: {
      fontFamily: '"JetBrains Mono", monospace',
      fontWeight: 600,
      letterSpacing: '-0.01em',
    },
    h3: {
      fontFamily: '"JetBrains Mono", monospace',
      fontWeight: 600,
    },
    h4: {
      fontFamily: '"JetBrains Mono", monospace',
      fontWeight: 500,
    },
    h5: {
      fontFamily: '"JetBrains Mono", monospace',
      fontWeight: 500,
    },
    h6: {
      fontFamily: '"JetBrains Mono", monospace',
      fontWeight: 500,
    },
    body1: {
      letterSpacing: '-0.01em',
    },
    body2: {
      letterSpacing: '-0.01em',
    },
    button: {
      fontFamily: '"JetBrains Mono", monospace',
      fontWeight: 500,
      letterSpacing: '0.02em',
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 6,
        },
        contained: {
          boxShadow: '0 4px 14px 0 rgba(139, 92, 246, 0.25)',
          '&:hover': {
            boxShadow: '0 6px 20px 0 rgba(139, 92, 246, 0.35)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          backgroundColor: 'rgba(30, 41, 59, 0.8)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(148, 163, 184, 0.1)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 500,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderColor: 'rgba(148, 163, 184, 0.1)',
        },
        head: {
          fontWeight: 600,
          backgroundColor: 'rgba(30, 41, 59, 0.5)',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#1e293b',
          borderRight: '1px solid rgba(148, 163, 184, 0.1)',
        },
      },
    },
  },
});

// Request type colors
export const REQUEST_TYPE_COLORS = {
  workflow: '#8b5cf6', // Violet
  workflow_plan: '#a78bfa', // Light violet
  query: '#3b82f6', // Blue
  agent: '#06b6d4', // Cyan
  checklist: '#f59e0b', // Amber
  compare: '#f97316', // Orange
  other: '#94a3b8', // Gray
};

// Chart colors
export const CHART_COLORS = [
  '#8b5cf6', // Violet
  '#3b82f6', // Blue
  '#22c55e', // Green
  '#f59e0b', // Amber
  '#ef4444', // Red
  '#ec4899', // Pink
  '#14b8a6', // Teal
  '#f97316', // Orange
];

export default theme;
